import { DATE_FORMAT } from "helpers/common";
import Badge from "react-bootstrap/Badge";
import React from "react";

const Columns = ({ deleteHandler, handleEdit, handleStatusToggle, handleViewHandler, permissions }) => [
  {
    dataField: "roundType",
    text: "Round Type",
    formatter: (_, row) => (
      <span className="">{row?.roundType || 0}</span>
    ),
  },
  {
    dataField: "energySpent",
    text: "Energy Spent",
    formatter: (_, row) => (
      <span className="">{row?.energySpent || 0}</span>
    ),
  },
  {
    dataField: "btncRewardReceived",
    text: "BTNc Reward",
    formatter: (_, row) => (
      <span className="">{row?.btncRewardReceived || 0}</span>
    ),
  },
  {
    dataField: "coinRewardReceived",
    text: "Coin Reward",
    formatter: (_, row) => (
      <span className="">{row?.coinRewardReceived || 0}</span>
    ),
  },
  {
    dataField: "jackpotRewardReceived",
    text: "Jackpot Reward",
    formatter: (_, row) => (
      <span className="">{row?.jackpotRewardReceived || 0}</span>
    ),
  },
  {
    dataField: "leaderboardPointsEarned",
    text: "Leaderboard Points",
    formatter: (_, row) => (
      <span className="">{row?.leaderboardPointsEarned || 0}</span>
    ),
  },
  {
    dataField: "userCount",
    text: "User Count",
    formatter: (_, row) => (
      <span className="">{row?.userCount || 0}</span>
    ),
  },
  {
    text: "Status",
    dataField: "status",
    formatter: (_, row) => (
      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          checked={row.status === "active"}
          disabled={!permissions?.edit}
          onChange={() => handleStatusToggle(row)}
        />
      </div>
    ),
  },
  {
    text: "Action",
    dataField: "action",
    formatter: (_, row) => (
      <div style={{ display: "flex", gap: "10px" }}>
        
        {/* View */}
        <button
          className="fas fa-eye"
          title="View"
          style={{
            fontSize: "16px",
            backgroundColor: "#fff",
            border: "none",
          }}
          onClick={() => handleViewHandler(row)}
        />
  
        {/* Edit */}
        {permissions?.edit && (
          <button
            className="fas fa-pen"
            title="Edit"
            style={{
              backgroundColor: "#fff",
              border: "none",
            }}
            onClick={() => handleEdit(row)}
          />
        )}
  
        {/* Delete */}
        {permissions?.delete && (
          <button
            className="fas fa-trash-alt"
            title="Remove"
            style={{
              backgroundColor: "#fff",
              border: "none",
            }}
            onClick={() => deleteHandler(row._id)}
          />
        )}
  
      </div>
    ),
  }
];
export default Columns;